const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_minimal/download_app.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_minimal/download_app")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});